(() => {
  'use strict';
  if (window.PMVPreorderDatesLayout || !document.body.classList.contains('template-product')) return;
  let guard, copy;
  try {
    guard = JSON.parse(document.getElementById('pmv-preorder-guard-bootstrap').textContent);
    copy = JSON.parse(document.getElementById('pmv-preorder-policy-copy').textContent);
  } catch (_) { return; }
  const productVariants = new Set((guard.initial?.productVariants || []).map(row => String(row.variantId || '').split('/').pop()).filter(value => /^[0-9]+$/.test(value)));
  if (guard.initial?.schema !== 1 || !productVariants.size) return;
  function selectedProductVariant(context) {
    // The hidden sticky and installment forms can still hold a prior variant.
    const forms = context?.querySelectorAll('.product__buy-buttons > product-form > form[data-type="add-to-cart-form"]');
    if (forms?.length !== 1) return null;
    const inputs = forms[0].querySelectorAll('input[name="id"]');
    // A disabled main input remains the selected identity for sold-out information.
    return inputs.length === 1 ? String(inputs[0].value || '') : null;
  }
  function matchesProduct(card) {
    const context = card.closest('.product__info-container');
    const selected = selectedProductVariant(context);
    return selected !== null && productVariants.has(selected) &&
      (!card.matches('[data-pmv-stoq-info]') || card.dataset.variantId === selected);
  }
  if (![copy.releaseLabel, copy.shippingLabel].every(value => typeof value === 'string' && value.trim())) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const selector = '.product__info-container .restock-rocket-preorder-description, .product__info-container .pmv-stoq-reserved[data-pmv-stoq-info]';
  const marker = 'data-pmv-dates-ready';
  const owned = '[data-pmv-preorder-dates]';
  const presentations = owned + ', [data-pmv-preorder-policy]';
  const records = new Map();
  const datePattern = '(?:January|February|March|April|May|June|July|August|September|October|November|December) (?:[1-9]|[12][0-9]|3[01]), [0-9]{4}';
  const dated = new RegExp('^Release Date: (' + datePattern + ')\\. Estimated Shipping Date: (' + datePattern + '|To be confirmed)\\.$');
  let frame = 0, stopped = false;

  function calendarDate(value) {
    const [month, dayText, yearText] = value.replace(',', '').split(' ');
    const index = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(month);
    const day = Number(dayText), year = Number(yearText);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const limit = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][index];
    return year > 0 && day > 0 && day <= limit;
  }
  function parse(text) {
    const normalized = text.replace(/\s+/g, ' ').trim();
    const match = normalized.match(dated);
    if (match && calendarDate(match[1]) && (match[2] === 'To be confirmed' || calendarDate(match[2]))) return [[copy.releaseLabel, match[1]], [copy.shippingLabel, match[2]]];
    if (normalized === 'Estimated Shipping Date: To be confirmed.') return [[copy.shippingLabel, 'To be confirmed']];
    return null;
  }
  function visible(element) {
    if (!element || !element.getClientRects().length) return false;
    for (let node = element; node && node.nodeType === 1; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' ||
          style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  function originalVisible(card, source) {
    const marked = card.hasAttribute(marker);
    if (marked) card.removeAttribute(marker);
    try { return visible(source); }
    finally { if (marked) card.setAttribute(marker, ''); }
  }
  function restore(card) {
    card.removeAttribute(marker);
    const record = records.get(card);
    if (record) record.component.remove();
    for (const child of [...card.children]) if (child.matches(owned)) child.remove();
    records.delete(card);
  }
  function build(rows, source) {
    const component = document.createElement('dl');
    component.className = 'pmv-preorder-dates';
    component.setAttribute('data-pmv-preorder-dates', '');
    component.style.color = getComputedStyle(source).color;
    for (const [label, value] of rows) {
      const row = document.createElement('div');
      row.className = 'pmv-preorder-dates__row';
      const term = document.createElement('dt');
      term.className = 'pmv-preorder-dates__label';
      term.textContent = label;
      const detail = document.createElement('dd');
      detail.className = 'pmv-preorder-dates__value';
      detail.textContent = value;
      row.append(term, detail);
      component.append(row);
    }
    return component;
  }
  function update(card) {
    if (!matchesProduct(card)) { restore(card); return; }
    const reserved = card.matches('[data-pmv-stoq-info]');
    const reservedSources = reserved ? card.querySelectorAll(':scope > .pmv-stoq-reserved__dates') : null;
    const details = reserved ? (reservedSources.length === 1 ? reservedSources[0] : null) : card.querySelector(':scope > .preorder-description-details');
    const items = reserved ? null : details?.querySelectorAll(':scope > .preorder-detail-item');
    const source = reserved ? details : items?.length === 1 ? items[0].querySelector(':scope > .preorder-detail-text') : null;
    const complete = reserved || (source && items[0].textContent.trim() === source.textContent.trim() && details.textContent.trim() === source.textContent.trim());
    const rows = source && source.children.length === 0 && complete ? parse(source.textContent) : null;
    if (!rows || !originalVisible(card, source)) { restore(card); return; }
    const signature = source.textContent;
    const prior = records.get(card);
    if (prior && prior.source === source && prior.details === details && prior.signature === signature && prior.component.parentElement === card) {
      const color = getComputedStyle(source).color;
      if (prior.component.style.color !== color) prior.component.style.color = color;
      return;
    }
    restore(card);
    let component;
    try {
      component = build(rows, source);
      card.insertBefore(component, details);
      const values = [...component.querySelectorAll('dd')].map(node => node.textContent);
      if (component.parentElement !== card || values.length !== rows.length || values.some((value, index) => value !== rows[index][1])) throw new Error('Date presentation incomplete');
      records.set(card, { component, source, details, signature });
      card.setAttribute(marker, '');
    } catch (_) {
      component?.remove();
      restore(card);
    }
  }
  function reconcile() {
    frame = 0;
    if (stopped) return;
    for (const card of records.keys()) if (!card.isConnected || !root.contains(card)) restore(card);
    for (const card of root.querySelectorAll(selector)) {
      try { update(card); }
      catch (_) { restore(card); }
    }
  }
  function schedule() {
    if (!stopped && !frame) frame = requestAnimationFrame(reconcile);
  }
  function insidePresentation(node) {
    const element = node?.nodeType === 1 ? node : node?.parentElement;
    return !!element?.closest(presentations);
  }
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => {
      if (insidePresentation(mutation.target)) return false;
      if (mutation.type !== 'childList') return true;
      const changed = [...mutation.addedNodes, ...mutation.removedNodes];
      return mutation.removedNodes.length > 0 || !changed.length || !changed.every(node => node.nodeType === 1 && node.matches(presentations));
    })) schedule();
  });
  observer.observe(root, { childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden', 'value', 'name', 'form', 'action'] });
  root.addEventListener('change', schedule, true);
  window.PMVPreorderDatesLayout = {
    refresh: schedule,
    destroy() {
      stopped = true;
      cancelAnimationFrame(frame);
      observer.disconnect();
      root.removeEventListener('change', schedule, true);
      for (const card of [...records.keys()]) restore(card);
      delete window.PMVPreorderDatesLayout;
    }
  };
  schedule();
})();
